<script setup>
import i18n from "@/i18n"
import { toRefs, defineProps, defineEmits, inject } from "vue";
import { uploadFile } from "@/service";
import SwiperTool from "@/components/swiperTool.vue";
import { useRoute } from "vue-router";
import { getLangValue } from "@/utils/common"; //获取后端语言
// import { getFileUrl } from "@/service"
// 注入通知函数
const openAlert = inject('openAlert')
const props = defineProps({
    uploadList: {
        type: Array,
        required: true,
        default: () => []
    },
    isCheckForm: {
        type: Boolean,
        default: false
    },
})
const route = useRoute()
const emits = defineEmits(["update:uploadList"])
const { uploadList } = toRefs(props)
/**文件上传部分 */
const checkFile = (index, file) => {
    const { fileList, accept } = uploadList.value[index]
    let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
    let suffix = name.substring(name.lastIndexOf("."));
    // 判断是否属于指定的类型
    if (accept.indexOf(suffix) == -1) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notCorrectType"),
            },
        );
        return false;
    }
    // 判断是否是同一个文件
    let arr = fileList.filter(item => item.filname == name)
    if (arr.length > 0) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notSameFile"),
            },
        );
        return false;
    }
    return true;
}
const selectedFile = (index) => {
    let idStr = '#' + uploadList.value[index].id;
    let fileMaxSize = uploadList.value[index].fileMaxSize
    let dropzoneFile = document.querySelector(idStr).files[0];
    if (!dropzoneFile) return;
    if (dropzoneFile.size > fileMaxSize) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.limit"),
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
    }
    if (!checkFile(index, dropzoneFile)) {
        document.getElementById("dropzoneFile").value = "";
        return;
    }
    // console.log(dropzoneFile);
    uploadFile(dropzoneFile)
        .then((res) => {
            uploadList.value[index].fileList.push(res.data.payload);
            emits("update:uploadList", uploadList.value)
             //清除上一张图片
            document.querySelector(idStr).value = ''
        })
        .catch((e) => {
            console.log(e);
        });

}
const drop = (e) => {
    let dropzoneFile = e.dataTransfer.files[0];
    if (!dropzoneFile) return;
}
const deleteFile = (i, _type, index) => {
    uploadList.value[index].fileList.splice(i, 1);
    emits("update:uploadList", uploadList.value)
}
// watch(uploadList, (val) => {
//     //判断是否有value
//     // console.log(val);
//     // val.forEach(item => {
//     //     if (item.value && item.value.length) {
//     //         let ids = item.value.join(',')
//     //         getFileUrl({ attachments: ids }).then(res=> {
//     //             res.payload.map(item=> {
//     //                 item.filename  = item.name
//     //             })
//     //             item.fileList = res.payload
//     //         })
//     //     }
//     // })
// },)
/**文件上传部分 */
</script>
<template>
    <!-- || item.key == '样式' || item.key == '设计版型' -->
    <b-card v-for="(item, index) in uploadList" :key="index"
        :style="route.query.type == 'view' ? { pointerEvents: 'none' } : {}" :id="`imageUpload${index}`">
        <div class="row gy-3 w-100">
            <div class="d-flex justify-content-between align-items-center pt-2 pb-2"
                style="font-weight: 500;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                <div>
                    <span class="text-danger" v-if="item.required">*</span>
                    {{ i18n.global.locale == 'en' ? item.name_en : item.name }}
                </div>
            </div>
            <div class="row  d-flex justify-content-start" v-if="item.fieldsList">
                <!-- 新增字段部分 -->
                <div class="col-4 mt-2" v-for="(field, index_field) in item.fieldsList" :key="index_field">
                    <label class="form-label">
                        <span class="text-danger" v-if="field.required">*</span>
                        <span>{{ i18n.global.locale == 'en' ? field.name_en : field.name  }}</span>
                    </label>
                    <div class="d-flex align-items-center">
                        <input type="text" v-model="field.value" :class="[(isCheckForm && !field.value && field.required) && 'is-invalid']"  class="form-control" style="flex: 1;">
                    </div>
                </div>
            </div>
            <!-- 上传框 -->
            <div>
                <DropZone :ipt-id="item.id" :title="getLangValue('upload.title')" :accept="item.accept"
                    @drop.prevent="drop" @change.prevent="selectedFile(index)" style="min-height: 220px" limit="50M"
                    :info="item.info ? item.info : ''" />
            </div>
            <!-- 预览 -->
            <div class=" border-solid rounded p-3" v-show="item.fileList && item.fileList.length">
                <div>
                    <div class="border-primary fs-14 material-title">{{ getLangValue("upload.uploadedFile") }}
                    </div>
                </div>
                <div class="product-img-slider  ps-5 pe-5">
                    <SwiperTool :swiperInfo="{
                        type: 'image',
                        page: 'assetform',
                        spaceBetween: 10,
                        slidesPerView: 15,
                        actionsClass: route.query.type != 'view' ? [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ] : [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                        ],
                    }" :list="item.fileList" @deleteFile="(...args) => deleteFile(...args, index)">
                    </SwiperTool>
                </div>
            </div>
        </div>
    </b-card>
</template>
<style></style>